import styled from '@emotion/styled'

export const SkatBoxWrapper = styled.div`
  flex: 0;
  min-width: 220px;
`
